import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import EVIncentives from "./../../client_customizations/components/EVIncentives/EVIncentives";
import EVJumbotronDropdown from "../../client_customizations/components/EVJumboTronDropdown/EVJumbotronDropdown";
import CostOfOwnership from "./../../client_customizations/components/CostOfOwnership/CostOfOwnership";
import LoadingSpinner from "../../components/LoadingSpinner/LoadingSpinner";

const UsedEV = ({ match, electricVehicles, userLocation, ip, uuid, isCanada }) => {
     const [usedEv, setUsedEv] = useState(null);
     const [usedEvs, setUsedEvs] = useState(null);

     useEffect(() => {
          const setElectricVehicles = () => {
               if (electricVehicles) {
                    const evId = match ? match.params["evId"].split(":") : "";
                    const make = evId[0].replace(/_/g, " ");
                    const model = evId[1].replace(/_/g, " ");
                    const trim = evId[2].replace(/_/g, " ");

                    const allUsedEvs = electricVehicles.filter((ev) => {
                         return ev.make === make && ev.model === model && ev.trim === trim;
                    });
                    setUsedEv(allUsedEvs[0]);
                    setUsedEvs(allUsedEvs);

                    document.title = make ? `Used Vehicle: ${make} ${model}` : "";
               }
          };
          setElectricVehicles();
     }, [electricVehicles, match]);

     const renderEV = usedEv ? (
          <>
               <EVJumbotronDropdown car={usedEv} incentives={usedEv.incentives} cars={usedEvs} setUsedEv={setUsedEv} />
               <CostOfOwnership cars={[usedEv, usedEv.equivalent_gas_vehicle]} usedEv={true} isCanada={isCanada} />
               <EVIncentives incentives={usedEv.incentives} car={usedEv} usedEv={true} />
          </>
     ) : (
          <div className="container text-center">
               <LoadingSpinner />
          </div>
     );

     return <>{renderEV}</>;
};

export default UsedEV;

UsedEV.propTypes = {
     match: PropTypes.object,
     electricVehicles: PropTypes.array,
     userLocation: PropTypes.object,
     ip: PropTypes.string,
     uuid: PropTypes.string
};
